/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCurrentVariant as getVariant } from 'ggApp/utils/product';
import {
    createSelector,
    createStructuredSelector,
} from 'reselect';

import { currentProductById as currentProductSelector } from 'ggApp/modules/product/selectors';

import {
    locationQuery as locationQuerySelector,
} from 'ggApp/modules/router/selectors';

import {
    currentProductByIdRentalPlans as rentalPlansSelector,
    rentalPlanIndexSelector,
    currentRentalPlanByProductIdSelector,
} from '../selectors';

const variantsSelector = createSelector(
    currentProductSelector,
    product => (product || {}).variants || [],
);

const currentVariantSelector = createSelector(
    variantsSelector,
    locationQuerySelector,
    (variants, locationQuery) => {
        const { variant_id: variantId } = locationQuery;

        return getVariant({
            availableVariants: variants,
            variantId,
        });
    },
);

export default function withPLPSelectPlanHandler(EnhancedComponent) {
    @connect(
        createStructuredSelector({
            rentalPlans: rentalPlansSelector,
            currentVariant: currentVariantSelector,
            selectedPlanIndex: rentalPlanIndexSelector,
            currentRentalPlan: currentRentalPlanByProductIdSelector,
        }),
    )
    class PLPSelectPlanHandlerHOC extends Component {
        static propTypes = {
            rentalPlans: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
            currentVariant: PropTypes.shape({}).isRequired,
            selectedPlanIndex: PropTypes.number.isRequired,
            currentRentalPlan: PropTypes.shape({}).isRequired,
        }

        render() {
            const {
                rentalPlans,
                currentVariant,
                selectedPlanIndex,
                currentRentalPlan,
                ...restProps
            } = this.props;

            return (
                <EnhancedComponent
                    rentalPlans={rentalPlans}
                    currentVariant={currentVariant}
                    selectedPlanIndex={selectedPlanIndex}
                    currentRentalPlan={currentRentalPlan}
                    {...restProps}
                />
            );
        }
    }

    return PLPSelectPlanHandlerHOC;
}
